import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { MODAL_TYPE_LOGGED_OUT } from '../../../../services/modal/constants';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../../constants/cookie';

import { showModal } from '../../../../services/modal/actions';

import useCartController from '../../../../services/ebon/hooks/useCartController';

import EbonSelectorLeftContainer from './EbonSelectorLeftContainer';
import EbonSelectorRightContainer from './EbonSelectorRightContainer';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './EbonSelectorComponentStyle.scss';

const EbonSelectorComponent = ({
    partner,
    i18n,
    isAuthenticated,
    fetching,
    ebonPaymentConfig,
    showModal,
    location
}) => {
    const {
        cart,
        handleItemChange,
        getCartTotal,
        addItemCart,
        getCartQuantity
    } = useCartController();

    const [cartStatusMessage, setCartStatusMessage] = useState('');

    const addItemCartWithStatus = useCallback(
        item => {
            addItemCart(item);
            setCartStatusMessage(i18n.ADDED_TO_BASKET);
            setTimeout(() => {
                const btn = document.querySelector(
                    `button[data-facial-value="${item.facialValue}"]`
                );
                if (btn) btn.focus();
            }, 100);
            setTimeout(() => setCartStatusMessage(''), 3000);
        },
        [addItemCart, i18n.ADDED_TO_BASKET]
    );

    const cartTotalQuantity = getCartQuantity(cart);
    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;
    const defaultBasketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimitDefault;
    const effectiveBasketLimit = basketLimit || defaultBasketLimit || undefined;

    const isBasketLimitReached = () => {
        return effectiveBasketLimit && cartTotalQuantity >= effectiveBasketLimit;
    };
    const getBasketLimitMessage = () => {
        if (basketLimit && cartTotalQuantity >= basketLimit) {
            return i18n.CAPPING_MESSAGE;
        }
        if (defaultBasketLimit && cartTotalQuantity >= defaultBasketLimit) {
            return i18n.DEFAULT_CAPPING_MESSAGE;
        }
        return undefined;
    };

    const showLoginModal = event => {
        if (!isAuthenticated) {
            event.preventDefault();
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, location.pathname);
            showModal(MODAL_TYPE_LOGGED_OUT, {
                id: 'logged-out-modal'
            });
            return false;
        }
    };

    return (
        <div id="ebon-selector-container" className="container">
            {fetching && (
                <div className="loading-div">
                    <LoadingComponent />
                </div>
            )}

            {!fetching && (
                <React.Fragment>
                    <div aria-live="polite" aria-atomic="true" className="sr-only">
                        {cartStatusMessage && <p>{cartStatusMessage}</p>}
                    </div>
                    <EbonSelectorLeftContainer
                        partner={partner}
                        cart={cart}
                        addItemCart={addItemCartWithStatus}
                        cartTotalQuantity={cartTotalQuantity}
                        basketLimit={effectiveBasketLimit}
                        isBasketLimitReached={isBasketLimitReached}
                        getBasketLimitMessage={getBasketLimitMessage}
                        loginRequired={!isAuthenticated}
                        showLoginModal={showLoginModal}
                    />
                    <EbonSelectorRightContainer
                        partner={partner}
                        cart={cart}
                        handleItemChange={handleItemChange}
                        getCartTotal={getCartTotal}
                        isBasketLimitReached={isBasketLimitReached}
                        loginRequired={!isAuthenticated}
                        showLoginModal={showLoginModal}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

EbonSelectorComponent.propTypes = {
    partner: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR,
        isAuthenticated: state.authentication.isAuthenticated,
        fetching: state.ebon.ebonsFetching,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorComponent));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/ebonselector/EbonSelectorComponent.js